var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 66,
    viewBox: "0 0 89 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1666 1H3.36301C2.05795 1 1 2.05156 1 3.34873V62.6513C1 63.9484 2.05795 65 3.36301 65H86.1666C87.4716 65 88.5296 63.9484 88.5296 62.6513V3.34873C88.5296 2.05156 87.4716 1 86.1666 1Z",
    stroke: "#733FE7",
    strokeWidth: 0.66154,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 34.0068H73.6162",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8066 23.7383L73.616 23.7383",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8066 18.6035L73.616 18.6035",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 38.4082H73.6162",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 43.543H73.6162",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6777 51.2451L73.6167 51.2451",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6699,
    y: 14.2031,
    width: 12.4695,
    height: 12.4695,
    fill: "#733FE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6848 7.60254H9.60156C8.49699 7.60254 7.60156 8.44617 7.60156 9.48684V57.0631C7.60156 58.1038 8.49699 58.9474 9.60156 58.9474H79.6848C80.7894 58.9474 81.6848 58.1038 81.6848 57.0631V9.48684C81.6848 8.44617 80.7894 7.60254 79.6848 7.60254Z",
    stroke: "#733FE7",
    strokeWidth: 2.93399,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c056b6a2.svg";
export { ForwardRef as ReactComponent };